import React from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import NachweisDetailEdit from './NachweisDetailEdit'

function mapStateToProps(state) {
  return {
    permissions: state.authentication.permissions,
    nachweisTyp: state.authentication.ausbildungsnachweistyp,
    hasVersetzungsplan: state.wizardtemplate.moduleSettings.hasVersetzungsplan,
  }
}

function withNachweisId(Component) {
  return function NachweisDetailEditContainer(props) {
    const nachweisId = useLocation().pathname.split('/').pop()
    return <Component {...props} nachweisId={nachweisId} />
  }
}

export default withNachweisId(connect(mapStateToProps)(NachweisDetailEdit))
